<template>
  <section class="mb-4">
    <h3 class="mc-control-tower-title">
      <span @click="toggleSection()">
        <i
          class="mc-fa"
          :class="collapsedSections ? 'icon-outline_chevron-down' : 'icon-outline_chevron-up'"
        ></i>
      </span>
      {{ title }} ({{ data.length }})
    </h3>
    <b-row class="mc-control-tower__list">
      <b-skeleton-wrapper :loading="isLoading">
        <template #loading>
          <b-col v-for="index in 9" :key="index" md="2">
            <div class="card mc-control-tower__list-skeleton">
              <div class="card-title">
                <b-skeleton width="80%" />
              </div>
              <div class="card-body">
                <b-skeleton width="60%" class="mb-2" />
                <b-skeleton width="50%" class="mb-2" />
                <b-skeleton width="40%" />
              </div>
            </div>
          </b-col>
        </template>

        <template v-if="data.length > 0">
          <b-col v-for="row in data" :key="row.vehicleId" md="2">
            <CTCard
              v-if="!collapsedSections"
              :item="row"
              :listKeys="listKeys"
              :isExpanded="isExpanded"
              @showDetail="showDetail"
              @setPin="setPin"
            />
          </b-col>
        </template>
        <b-col
          v-else-if="!isLoading && data.length == 0 && !collapsedSections"
          class="mc-control-tower__nofleet"
        >
          <div class="text-center text-muted">
            {{ $t('global.emptyFleet') }}
          </div>
        </b-col>
      </b-skeleton-wrapper>
    </b-row>
  </section>
</template>
<script>
import CTCard from './CTCard'

export default {
  components: {
    CTCard,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => [],
    },
    listKeys: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      collapsedSections: false,
    }
  },
  methods: {
    toggleSection() {
      this.collapsedSections = !this.collapsedSections
    },
    showDetail(item) {
      this.$emit('showDetail', item)
    },
    setPin(item) {
      this.$emit('setPin', item)
    },
  },
}
</script>
